module.exports = __webpack_public_path__ + "img/pictoPresentation1.b1b180ab.svg";